/* Corset Tank colourway swatches on product cards.
   Hover (desktop) or first tap (touch) previews a colour: swaps the card images,
   points the card links at that colour, and re-points quick-add sizes so the
   right colour is added. Click (desktop) or second tap goes to that colour. */
(function () {
  if (window.__tczCorsetSwatches) return;
  window.__tczCorsetSwatches = true;

  var WIDTHS = [165, 360, 535, 750, 940, 1100];
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function srcset(url) {
    return WIDTHS.map(function (w) {
      return url.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function rowOf(el) { return el.closest('.card__colors--tcz-corset'); }

  function apply(swatch) {
    var card = swatch.closest('.card-wrapper');
    if (!card) return;
    var row = rowOf(swatch);

    if (!card.dataset.tczUrl) {
      var active = row.querySelector('.color-swatch--tcz.is-active');
      card.dataset.tczUrl = (active || swatch).dataset.tczUrl;
    }
    var fromUrl = card.dataset.tczCurrent || card.dataset.tczUrl;
    var toUrl = swatch.dataset.tczUrl;

    var images = (swatch.dataset.tczImages || '').split('|').filter(Boolean);
    if (images.length) {
      card.querySelectorAll('.card-gallery__cell').forEach(function (cell, i) {
        var url = images[i] || images[0];
        var img = cell.querySelector('picture img');
        var source = cell.querySelector('picture source');
        if (img) { img.src = url; img.srcset = srcset(url); }
        if (source) source.srcset = srcset(url);
        var hover = cell.querySelector('.hover-img');
        if (hover) {
          var h = images[1] || images[0];
          hover.src = h; hover.srcset = srcset(h);
        }
      });
    }

    card.querySelectorAll('a[href]').forEach(function (a) {
      if (a.closest('.card__colors')) return;
      if (a.getAttribute('href') === fromUrl) a.setAttribute('href', toUrl);
    });
    card.dataset.tczCurrent = toUrl;

    var title = card.querySelector('.card-information__text');
    if (title && swatch.dataset.tczTitle) {
      title.innerHTML = swatch.dataset.tczTitle + ' <span class="colourway"></span>';
    }

    var variants = [];
    try { variants = JSON.parse(swatch.dataset.tczVariants || '[]'); } catch (e) {}
    var selector = card.querySelector('tcz-variant-selector');
    if (selector && variants.length) {
      var bySize = {};
      variants.forEach(function (v) { bySize[String(v.size).toUpperCase()] = v; });
      var buttons = Array.prototype.slice.call(selector.querySelectorAll('.tcz-variant-btn'));
      if (selector.mobileSheet) {
        buttons = buttons.concat(Array.prototype.slice.call(selector.mobileSheet.querySelectorAll('.tcz-variant-btn')));
      }
      buttons.forEach(function (btn) {
        var v = bySize[btn.textContent.trim().toUpperCase()];
        if (!btn.dataset.tczBound) {
          btn.dataset.tczBound = '1';
          btn.dataset.tczOrigDisabled = btn.disabled ? '1' : '';
        }
        if (v && v.available) {
          btn.dataset.variantId = v.id;
          btn.disabled = false;
          btn.classList.remove('tcz-variant-btn--soldout');
          btn.style.display = '';
        } else if (v) {
          btn.disabled = true;
          btn.classList.add('tcz-variant-btn--soldout');
          btn.style.display = '';
        } else {
          btn.style.display = 'none';
        }
      });
    }

    row.querySelectorAll('.color-swatch--tcz').forEach(function (s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.tcz-variant-btn[data-tcz-orig-disabled="1"]');
    if (!btn || btn.disabled) return;
    var sels = document.querySelectorAll('tcz-variant-selector');
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i];
      if (sel.contains(btn) || (sel.mobileSheet && sel.mobileSheet.contains(btn))) {
        sel.addToCart(btn, btn.dataset.variantId);
        break;
      }
    }
  });

  document.addEventListener('mouseover', function (e) {
    if (!canHover) return;
    var s = e.target.closest && e.target.closest('.color-swatch--tcz');
    if (s && !s.classList.contains('is-active')) apply(s);
  });

  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.color-swatch--tcz');
    if (!s) return;
    if (!canHover && !s.classList.contains('is-active')) {
      e.preventDefault();
      apply(s);
    }
  });
})();
